export const ABORT_MESSAGES = {
  IN_PROGRESS: 'Request in progress'
};
export const STATUS = {
  ABORTED: 'aborted',
  COMPLETED: 'completed'
};
export const MODULES = {
  DASHBOARD: 'dashboard',
  PRODUCT_ANALYTICS: 'productAnalytics'
};
export const KPIS_TABS = ['Global', 'Product', 'Advertising', 'Sellers', 'Country'];
export const KPIS_VIEWS = ['Performance', 'Advertising', 'Pricing and Margin', 'Inventory Coverage', 'Targeting', 'Campaigns'];
export const ERRORS = {
  INVALID_ROUTE: 'Invalid route'
};
export const CREDENTIALS_ERROR = {
  WRONG_CREDENTIALS_ERROR: 'Wrong username or password. Please try again.',
  WRONG_CREDENTIALS_ERROR_SERVER: 'Sorry Login has failed due to internal error, please contact support.'
};
export const EVENTS = {
  REFRESH_APPLICATION: 'refreshApplication',
  GLOBAL_PERFORMANCE: 'refreshGlobalPerformance',
  GLOBAL_ADVERTISING: 'refreshGlobalAdvertising',
  COUNTRY_PERFORMANCE: 'refreshCountryPerformance',
  COUNTRY_ADVERTISING: 'refreshCountryAdvertising',
  PRODUCT_PERFORMANCE: 'refreshProductPerformance',
  PRODUCT_ADVERTISING: 'refreshProductAdvertising',
  PRODUCT_INVENTORY_COVERAGE: 'refreshInventoryCoverage',
  PRODUCT_PRICING_MARGIN: 'refreshPricingAndMargin',
  ADVERTISING_TARGETING: 'refreshAdvertisingTargeting',
  ADVERTISING_CAMPAIGNS: 'refreshAdvertisingCampaigns',
  SELLERS_PERFORMANCE: 'refreshSellersPerformance',
  SELLERS_ADVERTISING: 'refreshSellersAdvertising',
  SIDEBAR_CHANGED: 'sidebarChanged',
  CLOSE_SIDEBAR: 'closeSidebar',
  OPEN_SIDEBAR: 'openSidebar',
  RESET_DATE_PICKER: 'resetDatePicker',
  CALENDAR_AUTO_SCROLL: 'calendarAutoScroll',
  REFRESH_PPC_SELLER_FILTER: 'refreshPpcSellerFilter',
  REFRESH_PPC_MARKETPLACE_FILTER: 'refreshPpcMarketplaceFilter',
  REFRESH_PPC_PRODUCT_FILTER: 'refreshPpcProductFilter',
  REFRESH_PPC_MATCH_TYPE_FILTER: 'refreshPpcMatchTypeFilter',
  REFRESH_PPC_MANAGEMENT: 'refreshPpcManagement',
  REFRESH_PPC_AUTOMATION_STATUS: 'refreshPpcAutomationStatus',
  REFRESH_SELLERS_SUB_FILTERS: 'refreshSellersSubFilters',
  REFRESH_SETTINGS_SELLERS_SUB_FILTERS: 'refreshSettingsSellersSubFilters',
  REFRESH_MARKETPLACES_SUB_FILTERS: 'refreshMarketplacesSubFilters',
  REFRESH_SETTINGS_MARKETPLACES_SUB_FILTERS: 'refreshSettingsMarketplacesSubFilters',
  REFRESH_PPC_TOP_SECTION_FILTERS: 'refreshPpcTopSectionFilters',
  CLOSE_FILTER_DROPDOWN: 'closeFilterDropdown',
  CLOSE_PRODUCT_TABLE_COLLAPSE: 'closeProductTableCollapse',
  OPEN_PRODUCT_TABLE_COLLAPSE: 'openProductTableCollapse',
  REFRESH_PPC_SETTINGS_BUDGET_STRATEGY: 'refreshPpcBudgetStrategy',
  REFRESH_PPC_SETTINGS_SB_BUDGET_STRATEGY: 'refreshPpcSbBudgetStrategy',
  REFRESH_PPC_SETTINGS: 'refreshPpcSettings',
  REFRESH_PPC_SETTINGS_BID_SETTINGS: 'refreshPpcBidSettings',
  REFRESH_PPC_SETTINGS_PRODUCT_PRIORITIZATION: 'refreshPpcProductPrioritization',
  REFRESH_PPC_SETTINGS_SB_PRODUCT_PRIORITIZATION: 'refreshPpcSBProductPrioritization',
  REFRESH_PPC_SETTINGS_BID_SIMULATOR: 'refreshPpcBidSimulator',
  REFRESH_PPC_WEEKS_RANGE: 'refreshPpcWeeksRange',
  PPC_STRATEGY_AUTO_SCROLL: 'ppcStrategyAutoScroll',
  REFRESH_PPC_SB_WEEKS_RANGE: 'refreshPpcSbWeeksRange',
  PPC_SB_STRATEGY_AUTO_SCROLL: 'ppcSbStrategyAutoScroll',
  PPC_HANDLE_COLLAPSED: 'ppcHandleCollapsed',
  REFRESH_PPC_SETTINGS_SELLERS_FILTER: 'refreshSellersFilter',
  REFRESH_PPC_SETTINGS_MARKETPLACES_FILTER: 'refreshMarketPlacesFilter',
  // ProductTableGroupBy
  ADD_SELLER_GROUPBY: 'addSellersGroupBy',
  ADD_MARKETPLACE_GROUPBY: 'addMarketplacesGroupBy',
  // Profit and Loss
  REFRESH_PROFIT_AND_LOSS: 'refreshProfitAndLoss',
  REFRESH_PROFIT_AND_LOSS_SELLERS_SUB_FILTERS: 'refreshProfitAndLossSellersSubFilters',
  REFRESH_PROFIT_AND_LOSS_MARKETPLACES_SUB_FILTERS: 'REFRESH_PROFIT_AND_LOSS_MARKETPLACES_SUB_FILTERS',
  PROFIT_AND_LOSS_DATE_PICKER_SUBMIT: 'profitAndLossDatePickerSubmit',
  REFRESH_DEMAND_FORECASTING_PAGE: 'refreshDemandForecastingPage',
  REFRESH_PRODUCT_DATA_PAGE: 'refreshProductDataPage',
  REFRESH_PRODUCT_DATA_SELLERS_SUB_FILTERS: 'refreshProductDataSellersSubFilters',
  REFRESH_COGS_DATA_PAGE: 'refreshCogsDataPage',
  CHANGE_PRODUCT_DATA_SCALE: 'handleProductDataScaleChange',
  REFRESH_DEMAND_FORECASTING_SETTINGS: 'refreshDemandForecastingSettings',
  REFRESH_DEMAND_FORECASTING_SELLERS_SUB_FILTERS: 'refreshDemandForecastingSellersSubFilters',
  //Pricing and margin

  REFRESH_PRICING_AND_MARGIN_DATA_PAGE: 'refreshPricingAndMarginDataPage',
  REFRESH_PRICING_AND_MARGIN_SELLERS_SUB_FILTERS: 'refreshPricingAndMarginSellersSubFilters',
  REFRESH_PRICING_AND_MARGIN_MARKETPLACES_SUB_FILTERS: 'refreshPricingAndMarginMarketplacesSubFilters',
  // DashboardV2
  REFRESH_DASHBOARD_V2_SELLERS_SUB_FILTERS: 'refreshDashboardV2SellersSubFilters',
  REFRESH_DASHBOARD_V2_MARKETPLACES_SUB_FILTERS: 'refreshMarketsV2SellersSubFilters',
  REFRESH_DASHBOARD_V2_PRODUCTS_SUB_FILTERS: 'refreshDashboardV2ProductsSubFilters',
  REFRESH_DASHBOARD_V2: 'refreshDashboardV2',
  OPEN_DASHBOARD_V2_PRODUCT_TABLE: 'openDashboardV2ProductTable',
  // Product Sub-Filters (triggered by segment selection)
  REFRESH_PROFIT_AND_LOSS_PRODUCTS_SUB_FILTERS: 'refreshProfitAndLossProductsSubFilters',
  REFRESH_DEMAND_FORECASTING_PRODUCTS_SUB_FILTERS: 'refreshDemandForecastingProductsSubFilters',
  REFRESH_PRODUCT_DATA_PRODUCTS_SUB_FILTERS: 'refreshProductDataProductsSubFilters',
  REFRESH_COGS_DATA_PRODUCTS_SUB_FILTERS: 'refreshCogsDataProductsSubFilters',
  REFRESH_PRICING_AND_MARGIN_PRODUCTS_SUB_FILTERS: 'refreshPricingAndMarginProductsSubFilters',
  // Floating Compound Table
  FLOATING_COMPOUND_TABLE_CLOSE_COLLAPSE: 'FLOATING_COMPOUND_TABLE_CLOSE_COLLAPSE',
  FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE: 'FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE',
  FLOATING_COMPOUND_TABLE_UPDATE_TABLE_HEIGHT: 'FLOATING_COMPOUND_TABLE_UPDATE_TABLE_HEIGHT',
  // Datepicker
  SETUP_DATE_PICKER: "SETUP_DATE_PICKER",
  REFRESH_SEO_PAGE: "REFRESH_SEO_PAGE",
  REFRESH_SEO_PAGE_COUNTRIES: "REFRESH_SEO_PAGE_COUNTRIES",
  REFRESH_SEO_PAGE_CONTENT_AND_SUGGESTIONS: "REFRESH_SEO_PAGE_CONTENT_AND_SUGGESTIONS",
  REFRESH_SEO_PAGE_CONTENT_TABLE: "REFRESH_SEO_PAGE_CONTENT_TABLE",
  REFRESH_SEO_PAGE_SELLERS_SUB_FILTERS: "REFRESH_SEO_PAGE_SELLERS_SUB_FILTERS",
  SEO_PUSH_MODAL_OPEN: "SEO_PUSH_MODAL_OPEN",
  SEO_PUSH_MODAL_CANCEL: "SEO_PUSH_MODAL_CANCEL",
  SEO_PUSH_MODAL_SUBMIT_MODIFIED_CONTENT: "SEO_PUSH_MODAL_SUBMIT_MODIFIED_CONTENT",
  REFRESH_SEO_PAGE_SUGGESTIONS: "REFRESH_SEO_PAGE_SUGGESTIONS",
  SEO_TABLE_SCROLL_TO_RIGHT: "SEO_TABLE_SCROLL_TO_RIGHT",
  // Toggle More Filters for Advertising Page
  SET_MORE_FILTERS: 'SET_MORE_FILTERS',
  DELETE_PPC_STRATEGY: 'DELETE_PPC_STRATEGY',
  DELETE_PPC_SB_STRATEGY: 'DELETE_PPC_SB_STRATEGY',
  MIXPANEL_TRACK: 'mixpanelTrack',
  // PPC Settings
  PPC_SETTINGS_INITIALIZED: 'ppcSettingsInitialized',
  // Market Insights
  REFRESH_MARKET_INSIGHTS_SELLERS_SUB_FILTERS: 'refreshMarketInsightsSellersSubFilters',
  REFRESH_MARKET_INSIGHTS_MARKETPLACES_SUB_FILTERS: 'refreshMarketInsightsMarketplacesSubFilters',
  REFRESH_MARKET_INSIGHTS: 'refreshMarketInsights',
  //Customer Insights
  REFRESH_CUSTOMER_INSIGHTS_SELLERS_SUB_FILTERS: 'refreshCustomerInsightsSellersSubFilters',
  REFRESH_CUSTOMER_INSIGHTS_MARKETPLACES_SUB_FILTERS: 'refreshCustomerInsightsMarketplacesSubFilters',
  REFRESH_CUSTOMER_INSIGHTS: 'refreshCustomerInsights',
  // Search Funnel
  REFRESH_SEARCH_FUNNEL_SELLERS_SUB_FILTERS: 'refreshSearchFunnelSellersSubFilters',
  REFRESH_SEARCH_FUNNEL_MARKETPLACES_SUB_FILTERS: 'refreshSearchFunnelMarketplacesSubFilters',
  REFRESH_SEARCH_FUNNEL: 'refreshSearchFunnel',
  CLEAR_SEARCH_FUNNEL_MORE_FILTERS: 'CLEAR_SEARCH_FUNNEL_MORE_FILTERS',
  REFRESH_SEARCH_FUNNEL_PRODUCTS_SUB_FILTERS: 'refreshSearchFunnelProductsSubFilters',
  REFRESH_SEARCH_FUNNEL_KEYWORD_TYPE_SUB_FILTERS: 'refreshSearchFunnelKeywordTypeSubFilters',
  SHOW_MUST_LOGIN: "SHOW_MUST_LOGIN",
  REFRESH_PPC_V2_SELLERS_SUB_FILTERS: "REFRESH_PPC_V2_SELLERS_SUB_FILTERS",
  REFRESH_PPC_V2_MARKETPLACES_SUB_FILTERS: "REFRESH_PPC_V2_MARKETPLACES_SUB_FILTERS",
  ADD_PPC_FILTER: "ADD_PPC_FILTER",
  SWITCH_COMPARE_TO_PREV_PERIOD: "SWITCH_COMPARE_TO_PREV_PERIOD",
  SWITCH_COMPARE_TO_SAME_PERIOD_LY: "SWITCH_COMPARE_TO_SAME_PERIOD_LY",
  REFRESH_COGS_DATA_SELLERS_SUB_FILTERS: "REFRESH_COGS_DATA_SELLERS_SUB_FILTERS",
  REFRESH_DSP_SELLERS_SUB_FILTERS: 'refreshDSPSellersSubFilters',
  REFRESH_DSP_MARKETPLACES_SUB_FILTERS: 'refreshDSPMarketplacesSubFilters',
  REFRESH_DSP: 'refreshDSP',
  REFRESH_DSP_CAMPAIGNS_SUB_FILTERS: 'refreshDSPCampaignsSubFilters',
  REFRESH_DSP_OVERVIEW: 'refreshDSPOverview'
};
export const DEFAULT_DATE_FORMATS = {
  WEEK: "MMM D, YYYY",
  WEEKLY: "MMM D, YYYY",
  MONTH: "MMM YYYY",
  MONTHLY: "MMM YYYY",
  DAY: "MMM D, YYYY",
  DAILY: "MMM D, YYYY",
  YEARLY: "YYYY",
  QUARTERLY: "[Q]Q - YYYY"
};
export const CHART_EXPORT_DATE_FORMATS = {
  DAY: "D MMM 'YY",
  DAILY: "D MMM 'YY",
  WEEK: "D MMM 'YY",
  WEEKLY: "D MMM 'YY",
  MONTH: "MMM 'YY",
  MONTHLY: "MMM 'YY",
  QUARTERLY: "[Q]Q 'YY",
  YEARLY: "'YY"
};
export const PPC_V2_DATE_FORMATS = {
  WEEKLY: "MMM DD, 'YY",
  MONTHLY: "MMM, 'YY",
  DAILY: "MMM DD, 'YY",
  YEARLY: 'YYYY',
  QUARTERLY: "[Q]Q - YYYY"
};
export const BAR_CHART_MINIMUM_PERCENTAGE = 0.8;
export const CM_TO_INCH_COEF = 0.393701;
export const INCH_TO_CM_COEF = 2.54;
export const KG_TO_LB_COEF = 2.20462;
export const LB_TO_KG_COEF = 0.453592;
export const CSV_EXPORT_ROW_LIMIT = 1000;

// Idle timeout before prompting login: matches OMNY_AUTH cookie lifetime (24hrs)
export const IDLE_TIMEOUT = 86400 * 1000;
export const AI_VERSION_SUGGESTIONS = {
  'amazon_version': 'Amazon Version',
  'amazon_seller_central_version': 'Amazon Seller Central Version',
  'omny_version': 'OMNY Version'
};
export const COLORS = {
  EVOLUTION_GREEN: '#68B67D',
  EVOLUTION_RED: '#E7747A',
  GREEN: '#47D16C',
  DARK_GREEN: '#22863D',
  YELLOW: '#D7AA0F',
  RED: '#E7747A',
  GRAY: '#999999',
  GREEN600: '#5de481',
  GREEN500: '#81ea9c',
  GREEN400: '#9fefb4',
  GREEN300: '#C2F5CF',
  YELLOW300: '#FFE27B',
  YELLOW400: '#F5D114',
  YELLOW500: '#E0BC00',
  YELLOW600: '#d7aa0f',
  YELLOW700: '#8f710a',
  YELLOW800: '#f0c329',
  RED400: '#FF8F94',
  TRANSPARENT: 'transparent',
  GRAY_BLUE: '#E8EBF3',
  DARK_GRAY: '#54595E',
  DARK_RED: '#DB333B',
  COMPETITORS_PURPLE: "#9447FF",
  NON_BRANDED_BLUE: "#8AB4FF",
  BRANDED_PINK: "#F174AA",
  DISCOVERY_GREY: "#E8EBF3",
  PURPLE600: '#C194FF',
  PURPLE500: '#CEABFF',
  PURPLE400: '#DCC3FF',
  PURPLE300: '#EADAFF',
  PURPLE200: '#F7F1FF',
  PURPLE100: '#F7F1FF',
  BLUE800: '#1B53B4',
  BLUE700: '#4C8EFF',
  BLUE600: '#85B2FF',
  BLUE500: '#A0C3FF',
  BLUE400: '#BBD4FF',
  BLUE300: '#D5E5FF',
  BLUE200: '#EFF5FF',
  BLUE100: '#FFFFFF',
  BLUE150: '#E0ECFF',
  PINK600: '#FF91C1',
  PINK500: '#FFA5CC',
  PINK400: '#FFB8D7',
  PINK300: '#FFD4E7',
  PINK200: '#FFEEF5',
  PINK100: '#FFFFFF',
  GREY900: '#595959',
  GREY800: '#BFBFBF',
  GREY600: '#AAADB5',
  GREY500: '#BCBFC7',
  GREY400: '#CED1D9',
  GREY300: '#E0E3EB',
  GREY200: '#F1F4FC',
  GREY100: '#FFFFFF',
  PURPLE700: '#6F22DA',
  PINK700: '#9F2258',
  GREY700: '#4D4D4D',
  MAGENTA100: '#FFF0F7',
  COOL_GREY_100: '#FFFFFF',
  COOL_GREY_200: '#EBF7FF',
  COOL_GREY_300: '#D4E7F4',
  COOL_GREY_400: '#C2D5E2',
  COOL_GREY_500: '#B0C3D0',
  COOL_GREY_600: '#9EB1BE',
  COOL_GREY_700: '#3E515E',
  RED700: '#DB333B'
};
export const CPC_DECILE_COLORS = {
  0: COLORS.GREEN600,
  1: COLORS.GREEN500,
  2: COLORS.GREEN400,
  3: COLORS.GREEN300,
  4: COLORS.GREEN300,
  5: COLORS.YELLOW300,
  6: COLORS.YELLOW400,
  7: COLORS.YELLOW500
};
export const PROFIT_DECILE_COLORS = {
  0: "#FFF5F5",
  1: "#FEEFEF",
  2: "#FCE9E9",
  3: "#FBE3E3",
  4: "#F9DCDC",
  5: "#F8D6D6",
  6: "#F6D0D0",
  7: "#F4C9C9",
  8: "#F3C3C3",
  9: "#F1BDBD",
  10: "#F0B7B7",
  11: "#EEB0B0",
  12: "#EDAAAA",
  13: "#EBA4A4",
  14: "#EA9E9E"
};
export const PROFIT_REVENUE_PERCENTAGE_DECILE_COLORS = {
  0: "#F8F5FF",
  1: "#EEE5FF",
  2: "#E3D8F8",
  3: "#D6C9ED",
  4: "#D6C9ED"
};
export const TARGETING_TYPE_TYPES = {
  COMPETITORS_PRODUCT: "A.Competitors Product",
  NON_BRANDED_KWS: "B.Non-Branded KW",
  BRANDED: "C.Branded",
  DISCOVERY: "D.Discovery"
};
export const TARGETING_SPLIT_TYPES_COLORS = {
  [TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT]: {
    0: COLORS.PURPLE200,
    1: COLORS.PURPLE300,
    2: COLORS.PURPLE400,
    3: COLORS.PURPLE500,
    4: COLORS.PURPLE600
  },
  [TARGETING_TYPE_TYPES.NON_BRANDED_KWS]: {
    0: COLORS.BLUE200,
    1: COLORS.BLUE300,
    2: COLORS.BLUE400,
    3: COLORS.BLUE500,
    4: COLORS.BLUE600
  },
  [TARGETING_TYPE_TYPES.BRANDED]: {
    0: COLORS.PINK200,
    1: COLORS.PINK300,
    2: COLORS.PINK400,
    3: COLORS.PINK500,
    4: COLORS.PINK600
  },
  [TARGETING_TYPE_TYPES.DISCOVERY]: {
    0: COLORS.GREY200,
    1: COLORS.GREY300,
    2: COLORS.GREY400,
    3: COLORS.GREY500,
    4: COLORS.GREY600
  }
};
export const ROAS_DECILE_COLORS = {
  0: COLORS.COOL_GREY_100,
  1: COLORS.COOL_GREY_200,
  2: COLORS.COOL_GREY_300,
  3: COLORS.COOL_GREY_400,
  4: COLORS.COOL_GREY_500,
  5: COLORS.COOL_GREY_600
};
export const KPIS_COLORS_BACKGROUND = {
  [COLORS.RED]: "#FFE5E7",
  [COLORS.GREEN]: "#E7F8E7",
  [COLORS.DARK_GREEN]: "#DEFBE6",
  [COLORS.TRANSPARENT]: "transparent",
  [COLORS.GRAY]: "#F5F5F5",
  [COLORS.GRAY_BLUE]: "#E8EBF3"
};
export const CAMPAIGNS_STATES = {
  PAUSED: COLORS.GRAY,
  ENABLED: COLORS.DARK_GREEN,
  ARCHIVED: COLORS.YELLOW
};
export const KPI_DIRECTION_TYPE = {
  SMALL_IS_GOOD: 'small_is_good',
  BIG_IS_GOOD: 'big_is_good'
};
export const TREND_DIRECTION_TYPE = {
  UP: 'up',
  DOWN: 'down',
  OFF: 'off'
};
export const GLOBAL_KPIS_DIRECTIONS = {
  TACOS: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  // meaning that the lower the better
  spend: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  // meaning that the lower the better
  sponsored_sales: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher the better
  CVR: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher the better
  CPC: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  // meaning that the lower the better
  ACOS: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  // meaning that the lower the better
  units_sold_clicks_14_d: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher the better
  clicks: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher the better,
  ROAS: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher the better
  revenue_excl_VAT: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher
  days_inventory_current_period: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  organic_CVR: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher
  traffic_by_asin_buy_box_percentage: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  share_sponsored_sales: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher the better
  lost_revenue_excl_VAT: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  last_year_revenue_excl_VAT: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  last_year_units_sold_clicks_14_d: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  last_year_total_quantity: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  last_year_days_inventory_current_period: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  last_year_lost_revenue_excl_VAT: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  last_year_TACOS: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  last_year_share_sponsored_sales: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  last_year_organic_CVR: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  last_year_traffic_by_asin_buy_box_percentage: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  total_quantity: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  page_views: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  last_year_page_views: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  active_asin_count: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  last_year_active_asin_count: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  last_year_spend: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  // meaning that the lower the better
  last_year_sponsored_sales: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher the better
  last_year_CVR: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher the better
  last_year_CPC: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  // meaning that the lower the better
  last_year_ACOS: KPI_DIRECTION_TYPE.SMALL_IS_GOOD,
  // meaning that the lower the better
  last_year_clicks: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher the better,
  last_year_ROAS: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher the better

  revenue_wtd: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher
  revenue_mtd: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher
  revenue_ytd: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher
  revenue_yesterday: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher

  last_year_revenue_wtd: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher
  last_year_revenue_mtd: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher
  last_year_revenue_ytd: KPI_DIRECTION_TYPE.BIG_IS_GOOD,
  // meaning that the higher
  last_year_revenue_yesterday: KPI_DIRECTION_TYPE.BIG_IS_GOOD // meaning that the higher
};
export const CVR_HEATMAP_COLORS = [[[Number.NEGATIVE_INFINITY, 0.019], `${COLORS.RED400}FF`], [[0.02, 0.05], `${COLORS.YELLOW800}FF`], [[0.05, 0.08], `${COLORS.YELLOW400}FF`], [[0.08, 0.12], `${COLORS.YELLOW300}FF`], [[0.12, 0.16], COLORS.GREEN300], [[0.16, 0.2], COLORS.GREEN400], [[0.20, 0.25], COLORS.GREEN500], [[0.25, Number.POSITIVE_INFINITY], COLORS.GREEN600]];
export const DAYS_INVENTORY_HEATMAP_COLORS = [[[Number.NEGATIVE_INFINITY, 20], '#CEDED3'], [[20, 100], '#A8E9BB'], [[100, Number.POSITIVE_INFINITY], '#88A991']];
export const ORGANIC_CVR_HEATMAP_COLORS = [...CVR_HEATMAP_COLORS];
export const KEYWORD_BID_HEATMAP_COLORS = [[[0, 0.20], "#4C8EFF"], [[0.20, 0.35], "#669EFF"], [[0.35, 0.50], "#80AFFF"], [[0.50, 0.65], "#FFC69E"], [[0.65, 0.9], "#FFB17A"], [[0.9, 1.25], "#FF9D57"], [[1.25, 1.5], "#F174AA"], [[1.5, 2.0], "#FFA8BD"], [[2.0, Number.POSITIVE_INFINITY], "#FFAFD2"]];
export const BUYBOX_HEATMAP_COLORS = [[[Number.NEGATIVE_INFINITY, 0.85], COLORS.RED], [[0.85, 0.95], COLORS.YELLOW], [[0.95, Number.POSITIVE_INFINITY], COLORS.GREEN]];
export const BEST_POSITION_HEATMAP_COLORS = [[[0, 3], COLORS.GREEN], [[3, 8], COLORS.YELLOW], [[8, Number.POSITIVE_INFINITY], COLORS.RED]];
export const DSP_DELIVERY_RATE_COLORS = [[[Number.NEGATIVE_INFINITY, 0.80], "#DB333B"], [[0.81, 0.90], "#8F710A"], [[0.91, 1], "#1A662E"], [[1.01, 1.2], "#8F710A"], [[1.21, Number.POSITIVE_INFINITY], "#DB333B"]];
export const DSP_DELIVERY_RATE_BG_COLORS = [[[Number.NEGATIVE_INFINITY, 0.80], "#FFE5E7"], [[0.81, 0.90], "#FDF6DE"], [[0.91, 1], "#DEFBE6"], [[1.01, 1.2], "#FDF6DE"], [[1.21, Number.POSITIVE_INFINITY], "#FFE5E7"]];
export const DSP_NTB_CUSTOMERS_RATE_COLORS = [[[Number.NEGATIVE_INFINITY, 0.85], "#DB333B"], [[0.86, 0.95], "#8F710A"], [[0.96, Number.POSITIVE_INFINITY], "#1A662E"]];
export const DSP_NTB_CUSTOMERS_RATE_BG_COLORS = [[[Number.NEGATIVE_INFINITY, 0.85], "#FFE5E7"], [[0.86, 0.95], "#FDF6DE"], [[0.96, Number.POSITIVE_INFINITY], "#DEFBE6"]];
export const FLOATING_COMPOUND_TABLE_STATES = {
  CLOSED: "closed",
  INTERMEDIATE: "intermediate",
  FULL_SIZE: "full-size"
};
export const GROUP_BY_TAB_ELEMENTS = {
  SELLER: {
    name: "Seller",
    key: "seller"
  },
  MARKETPLACE: {
    name: "Marketplace",
    key: "marketplace"
  },
  PRODUCT: {
    name: "Product",
    key: "product"
  },
  PRODUCT_SKU: {
    name: "Sku",
    key: "product"
  },
  CAMPAIGN_GROUP: {
    name: "Campaign Group",
    key: "campaign_group"
  },
  CAMPAIGN: {
    name: "Campaign",
    key: "campaign"
  },
  TARGETING: {
    name: "Targeting",
    key: "targeting"
  },
  PRODUCT_ASIN: {
    name: "ASIN",
    key: "asin"
  },
  PRODUCT_PARENT: {
    name: "Parent ASIN",
    key: "parent_asin"
  },
  AD_FORMAT: {
    name: "Ad Format",
    key: "ad_format"
  },
  SEGMENT: {
    name: "Segment",
    key: "segment",
    tagged: true
  },
  BRAND: {
    name: "Brand",
    key: "brand"
  },
  CATEGORY: {
    name: "Category",
    key: "category"
  },
  COMPETITOR: {
    name: "Competitor",
    key: "competitor"
  },
  KEYWORD: {
    name: "Keyword",
    key: "keyword"
  },
  KEYWORD_TYPE: {
    name: "Keyword type",
    key: "keyword_type"
  },
  LINE_ITEM: {
    name: "Line item",
    key: "line_item"
  },
  DSP_CAMPAIGN: {
    name: "Order",
    key: "campaign"
  }
};
export const APP_PERIOD_DROPDOWN_ELEMENTS = {
  DAILY: {
    text: "Daily",
    value: "daily",
    endOf: "day",
    unit: "day"
  },
  WEEKLY: {
    text: "Weekly",
    value: "weekly",
    endOf: "week",
    unit: "week"
  },
  MONTHLY: {
    text: "Monthly",
    value: "monthly",
    endOf: "month",
    unit: "month"
  },
  QUARTERLY: {
    text: "Quarterly",
    value: "quarterly",
    endOf: "quarter",
    unit: "quarter"
  },
  YEARLY: {
    text: "Yearly",
    value: "yearly",
    endOf: "year",
    unit: "year"
  },
  WEEK_TO_DATE: {
    text: "Week to date",
    value: "week_to_date",
    endOf: "week",
    unit: "week"
  },
  MONTH_TO_DATE: {
    text: "Month to date",
    value: "month_to_date",
    endOf: "month",
    unit: "month"
  },
  QUARTER_TO_DATE: {
    text: "Quarter to date",
    value: "quarter_to_date",
    endOf: "quarter",
    unit: "quarter"
  },
  YEAR_TO_DATE: {
    text: "Year to date",
    value: "year_to_date",
    endOf: "year",
    unit: "year"
  },
  LAST_WEEK: {
    text: "Last week",
    value: "last_week",
    endOf: "week",
    unit: "week"
  },
  LAST_MONTH: {
    text: "Last month",
    value: "last_month",
    endOf: "month",
    unit: "month"
  },
  LAST_QUARTER: {
    text: "Last quarter",
    value: "last_quarter",
    endOf: "quarter",
    unit: "quarter"
  }
};
export const PERIOD_COLUMN_TITLES = {
  daily: "Day",
  weekly: "Week",
  monthly: "Month",
  yearly: "Year",
  quarterly: "Quarter"
};
export const TARGETING_TYPE_SPLIT = [{
  name: "Competitors",
  short_name: "Competitors",
  abbreviation: 'Cp.',
  keyword_name: "Competitors KWs",
  key: TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT,
  color: COLORS.COMPETITORS_PURPLE,
  tableColor: COLORS.COMPETITORS_PURPLE,
  bg: COLORS.PURPLE200,
  dotColor: COLORS.COMPETITORS_PURPLE,
  definition: {
    title: "Competitor & products",
    detail: "Target your competitors keywords and products",
    titleColor: COLORS.COMPETITORS_PURPLE
  }
}, {
  name: "Non-Branded KWs",
  short_name: "Non-branded",
  abbreviation: 'NBr.',
  keyword_name: "Non-Branded KWs",
  key: TARGETING_TYPE_TYPES.NON_BRANDED_KWS,
  color: COLORS.NON_BRANDED_BLUE,
  tableColor: COLORS.BLUE700,
  dotColor: COLORS.NON_BRANDED_BLUE,
  bg: COLORS.BLUE150,
  definition: {
    title: "Non-branded",
    detail: "All high-performing keywords, excluding branded terms",
    titleColor: COLORS.NON_BRANDED_BLUE
  }
}, {
  name: "Branded",
  short_name: "Branded",
  abbreviation: 'Br.',
  keyword_name: "Branded KWs",
  key: TARGETING_TYPE_TYPES.BRANDED,
  color: COLORS.BRANDED_PINK,
  tableColor: COLORS.BRANDED_PINK,
  bg: COLORS.MAGENTA100,
  dotColor: COLORS.BRANDED_PINK,
  definition: {
    title: "Branded & products",
    detail: "Target your brand's keywords and products",
    titleColor: COLORS.BRANDED_PINK
  }
}, {
  name: "Discovery",
  short_name: "Discovery",
  abbreviation: 'Dis.',
  keyword_name: "Discovery KWs",
  key: TARGETING_TYPE_TYPES.DISCOVERY,
  color: COLORS.DISCOVERY_GREY,
  tableColor: COLORS.GREY700,
  bg: COLORS.GREY200,
  dotColor: COLORS.GREY800,
  definition: {
    title: "Discovery targeting",
    detail: "Auto and broad targeting to find new high-performing keywords",
    titleColor: COLORS.GREY900
  }
}];
export const TARGETING_TYPE_SPLIT_KEYMAP = {
  [TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT]: {
    name: "Competitors",
    short_name: "Competitors",
    key: TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT,
    color: COLORS.COMPETITORS_PURPLE,
    tableColor: COLORS.COMPETITORS_PURPLE,
    bg: COLORS.PURPLE200
  },
  [TARGETING_TYPE_TYPES.NON_BRANDED_KWS]: {
    name: "Non-Branded KWs",
    short_name: "Non-branded",
    key: TARGETING_TYPE_TYPES.NON_BRANDED_KWS,
    color: COLORS.NON_BRANDED_BLUE,
    tableColor: COLORS.BLUE700,
    bg: COLORS.BLUE150
  },
  [TARGETING_TYPE_TYPES.BRANDED]: {
    name: "Branded",
    short_name: "Branded",
    key: TARGETING_TYPE_TYPES.BRANDED,
    color: COLORS.BRANDED_PINK,
    tableColor: COLORS.BRANDED_PINK,
    bg: COLORS.MAGENTA100
  },
  [TARGETING_TYPE_TYPES.DISCOVERY]: {
    name: "Discovery",
    short_name: "Discovery",
    key: TARGETING_TYPE_TYPES.DISCOVERY,
    color: COLORS.DISCOVERY_GREY,
    tableColor: COLORS.GREY700,
    bg: COLORS.GREY200
  }
};
export const ANALYTICS_CSV_PAGE_SIZE = 500; // We are fetching 500 rows at time to reduce network calls to BQ

export const ANALYTICS_TABLE_CELL_HEIGHT = {
  [GROUP_BY_TAB_ELEMENTS.SELLER.key]: {
    '--lite-table-td-height': '32px'
  },
  [GROUP_BY_TAB_ELEMENTS.MARKETPLACE.key]: {
    '--lite-table-td-height': '32px'
  },
  [GROUP_BY_TAB_ELEMENTS.PRODUCT.key]: {
    '--lite-table-td-height': '47px'
  },
  [GROUP_BY_TAB_ELEMENTS.PRODUCT_ASIN.key]: {
    '--lite-table-td-height': '47px'
  },
  [GROUP_BY_TAB_ELEMENTS.PRODUCT_SKU.key]: {
    '--lite-table-td-height': '47px'
  },
  [GROUP_BY_TAB_ELEMENTS.PRODUCT_PARENT.key]: {
    '--lite-table-td-height': '47px'
  },
  [GROUP_BY_TAB_ELEMENTS.CAMPAIGN.key]: {
    '--lite-table-td-height': '47px'
  },
  [GROUP_BY_TAB_ELEMENTS.TARGETING.key]: {
    '--lite-table-td-height': '47px'
  },
  [GROUP_BY_TAB_ELEMENTS.CAMPAIGN_GROUP.key]: {
    '--lite-table-td-height': '47px'
  },
  [GROUP_BY_TAB_ELEMENTS.AD_FORMAT.key]: {
    '--lite-table-td-height': '32px'
  },
  [GROUP_BY_TAB_ELEMENTS.SEGMENT.key]: {
    '--lite-table-td-height': '47px'
  },
  [GROUP_BY_TAB_ELEMENTS.BRAND.key]: {
    '--lite-table-td-height': '47px'
  }
};
export const AD_PRODUCT_KEYMAP = {
  SPONSORED_BRANDS: "Sponsored Brands",
  SPONSORED_PRODUCTS: "Sponsored Products",
  SPONSORED_DISPLAY: "Sponsored Display"
};
export const PPC_EXTRA_FILTERS = {
  AD_FORMAT: "Ad Format",
  PORTFOLIO: "Portfolio",
  TARGETING: "Targeting",
  MATCH_TYPE: "Match Type",
  CAMPAIGN: "Campaigns",
  TARGETING_TYPE: "Targeting Type",
  CAMPAIGN_GROUP: "Campaign group"
};

// Order the PPC secondary filters render in. A filter comes after the ones that
// refresh it (see PPC_FILTER_REFRESH_RELATIONSHIPS).
export const PPC_EXTRA_FILTERS_ORDER = [PPC_EXTRA_FILTERS.PORTFOLIO, PPC_EXTRA_FILTERS.AD_FORMAT, PPC_EXTRA_FILTERS.CAMPAIGN_GROUP, PPC_EXTRA_FILTERS.CAMPAIGN, PPC_EXTRA_FILTERS.TARGETING_TYPE, PPC_EXTRA_FILTERS.TARGETING, PPC_EXTRA_FILTERS.MATCH_TYPE];
export const HANDLE_ADD_FILTER_MODES = {
  SILENT: "SILENT",
  POPUP: "POPUP"
};
export const PERIOD_OPTIONS = {
  PREV_PERIOD: {
    html: `Prev. period`,
    value: "prev_period",
    queryKey: "prev_period"
  },
  SAME_PERIOD_LY: {
    html: `Same period LY`,
    value: "same_period_ly",
    queryKey: "same_period_ly"
  }
};
export const PERIOD_OPTIONS_V2 = {
  [APP_PERIOD_DROPDOWN_ELEMENTS.DAILY.value]: {
    LEFT: {
      html: `vs same day previous week`,
      value: "same_day_prev_week",
      queryKey: "prev_period"
    },
    RIGHT: {
      html: `vs same day previous year`,
      value: "same_day_prev_year",
      queryKey: "same_period_ly"
    }
  },
  [APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value]: {
    LEFT: {
      html: `vs previous week`,
      value: "prev_week",
      queryKey: "prev_period"
    },
    RIGHT: {
      html: `vs same week previous year`,
      value: "same_week_prev_year",
      queryKey: "same_period_ly"
    }
  },
  [APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY.value]: {
    LEFT: {
      html: `vs previous month`,
      value: "prev_month",
      queryKey: "prev_period"
    },
    RIGHT: {
      html: `vs same month previous year`,
      value: "same_month_prev_year",
      queryKey: "same_period_ly"
    }
  },
  [APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY.value]: {
    LEFT: {
      html: `vs previous quarter`,
      value: "prev_quarter",
      queryKey: "prev_period"
    },
    RIGHT: {
      html: `vs same quarter previous year`,
      value: "same_quarter_prev_year",
      queryKey: "same_period_ly"
    }
  },
  [APP_PERIOD_DROPDOWN_ELEMENTS.YEARLY.value]: {
    LEFT: {
      html: `vs previous year`,
      value: "prev_year",
      queryKey: "prev_period"
    },
    RIGHT: {
      html: `vs same year two years ago`,
      value: "same_year_two_years_ago",
      queryKey: "same_period_ly"
    }
  }
};
export const APP_LTV_DROPDOWN_ELEMENTS = {
  LTV: {
    text: "LTV",
    value: "ltv_revenue_excl_vat",
    endOf: ""
  },
  REPEAT_LTV: {
    text: "Repeat LTV",
    value: "repeat_ltv_revenue_excl_vat",
    endOf: ""
  },
  REPEAT_AOV: {
    text: "Repeat AOV",
    value: "repeat_aov_revenue_excl_vat_cum",
    endOf: ""
  },
  REPURCHASE_RATE: {
    text: "Repurchase rate",
    value: "repurchase_rate_cum",
    endOf: ""
  },
  REPURCHASE_FREQUENCY: {
    text: "Repurchase frequency",
    value: "repurchase_frequency_cum",
    endOf: ""
  }
};
export const APP_LTV_OFFSET_DROPDOWN_ELEMENTS = {
  LTV_OFFSET_0: {
    text: "0 month",
    value: "ltv_offset_00",
    endOf: ""
  },
  LTV_OFFSET_1: {
    text: "1 month",
    value: "ltv_offset_01",
    endOf: ""
  },
  LTV_OFFSET_2: {
    text: "2 months",
    value: "ltv_offset_02",
    endOf: ""
  },
  LTV_OFFSET_3: {
    text: "3 months",
    value: "ltv_offset_03",
    endOf: ""
  },
  LTV_OFFSET_4: {
    text: "4 months",
    value: "ltv_offset_04",
    endOf: ""
  },
  LTV_OFFSET_5: {
    text: "5 months",
    value: "ltv_offset_05",
    endOf: ""
  },
  LTV_OFFSET_6: {
    text: "6 months",
    value: "ltv_offset_06",
    endOf: ""
  },
  LTV_OFFSET_7: {
    text: "7 months",
    value: "ltv_offset_07",
    endOf: ""
  },
  LTV_OFFSET_8: {
    text: "8 months",
    value: "ltv_offset_08",
    endOf: ""
  },
  LTV_OFFSET_9: {
    text: "9 months",
    value: "ltv_offset_09",
    endOf: ""
  },
  LTV_OFFSET_10: {
    text: "10 months",
    value: "ltv_offset_10",
    endOf: ""
  },
  LTV_OFFSET_11: {
    text: "11 months",
    value: "ltv_offset_11",
    endOf: ""
  },
  LTV_OFFSET_12: {
    text: "12 months",
    value: "ltv_offset_12",
    endOf: ""
  },
  LTV_OFFSET_13: {
    text: "13 months",
    value: "ltv_offset_13",
    endOf: ""
  },
  LTV_OFFSET_14: {
    text: "14 months",
    value: "ltv_offset_14",
    endOf: ""
  },
  LTV_OFFSET_15: {
    text: "15 months",
    value: "ltv_offset_15",
    endOf: ""
  },
  LTV_OFFSET_16: {
    text: "16 months",
    value: "ltv_offset_16",
    endOf: ""
  },
  LTV_OFFSET_17: {
    text: "17 months",
    value: "ltv_offset_17",
    endOf: ""
  },
  LTV_OFFSET_18: {
    text: "18 months",
    value: "ltv_offset_18",
    endOf: ""
  },
  LTV_OFFSET_19: {
    text: "19 months",
    value: "ltv_offset_19",
    endOf: ""
  },
  LTV_OFFSET_20: {
    text: "20 months",
    value: "ltv_offset_20",
    endOf: ""
  },
  LTV_OFFSET_21: {
    text: "21 months",
    value: "ltv_offset_21",
    endOf: ""
  },
  LTV_OFFSET_22: {
    text: "22 months",
    value: "ltv_offset_22",
    endOf: ""
  },
  LTV_OFFSET_23: {
    text: "23 months",
    value: "ltv_offset_23",
    endOf: ""
  },
  LTV_OFFSET_24: {
    text: "24 months",
    value: "ltv_offset_24",
    endOf: ""
  }
};
export const EXPORT_CSV_ROW_LIMIT = 30_000;
export const FILTER_KEYS = {
  SELLERS: "sellers",
  MARKETPLACES: "marketplaces",
  PRODUCTS: "products",
  CAMPAIGNS: "campaigns",
  PORTFOLIOS: "portfolios",
  AD_FORMATS: "ad_formats",
  MATCH_TYPES: "match_types",
  TARGETINGS: "targetings",
  CAMPAIGN_GROUPS: "campaign_groups",
  SEGMENTS: "segments",
  BRANDS: "brands",
  CATEGORIES: "categories",
  CURRENCIES: "currencies",
  TARGETING_TYPES: "targeting_types"
};

// Which filters must be re-initialized when a PPC filter is applied.
export const PPC_FILTER_REFRESH_RELATIONSHIPS = {
  [FILTER_KEYS.PORTFOLIOS]: [FILTER_KEYS.CAMPAIGNS, FILTER_KEYS.CAMPAIGN_GROUPS],
  [FILTER_KEYS.AD_FORMATS]: [FILTER_KEYS.CAMPAIGNS, FILTER_KEYS.CAMPAIGN_GROUPS],
  [FILTER_KEYS.CAMPAIGN_GROUPS]: [FILTER_KEYS.CAMPAIGNS]
};
export const PERIOD_OPTIONS_LEFT_RIGHT_EVENTS = {
  prev_period: EVENTS.SWITCH_COMPARE_TO_PREV_PERIOD,
  same_period_ly: EVENTS.SWITCH_COMPARE_TO_SAME_PERIOD_LY
};
export const SEARCH_FUNNEL_CVR_HEATMAP_COLORS = [[[0, 0.21], "#E2F2FE"], [[0.21, 0.41], "#C2DFF5"], [[0.41, 0.61], "#B3D3EA"], [[0.61, 0.81], "#A5C3D9"], [[0.81, Number.POSITIVE_INFINITY], "#89B0CC"]];
export const SEARCH_FUNNEL_CTR_HEATMAP_COLORS = [[[0, 0.21], "#CCF1E8"], [[0.21, 0.41], "#C2EDE3"], [[0.41, 0.61], "#AFDFD4"], [[0.61, 0.81], "#AAD3C9"], [[0.81, Number.POSITIVE_INFINITY], "#9EC6BD"]];
export const ECPM_DECILE_COLORS = {
  0: "#CCF1E8",
  1: "#C2EDE3",
  2: "#AFDFD4",
  3: "#AAD3C9",
  4: "#9EC6BD"
};
export const CUSTOMER_INSIGHTS_LTV_COLORS = {
  0: "#FFF6F0",
  1: "#FFE9DB",
  2: "#FEC9AA",
  3: "#F89053",
  4: "#BE510E"
};
const MAX_SLIDES_HEIGHT_PX = 500;
export const EXPORT_SIZES = {
  SQUARE: {
    height: MAX_SLIDES_HEIGHT_PX,
    width: MAX_SLIDES_HEIGHT_PX
  },
  LANDSCAPE_RECTANGLE: {
    height: MAX_SLIDES_HEIGHT_PX,
    width: Math.round(MAX_SLIDES_HEIGHT_PX * 4 / 3)
  },
  PORTRAIT_RECTANGLE: {
    height: MAX_SLIDES_HEIGHT_PX,
    width: Math.round(MAX_SLIDES_HEIGHT_PX * 3 / 4)
  },
  FULL_WIDTH: {
    height: MAX_SLIDES_HEIGHT_PX,
    width: Math.round(MAX_SLIDES_HEIGHT_PX * 2.3)
  }
};
export const EXPORT_LIMITS = {
  SQUARE: 4,
  LANDSCAPE_RECTANGLE: 6,
  PORTRAIT_RECTANGLE: 3,
  FULL_WIDTH: null
};

// Number of days before a strategy's end_date that we flag it as "due soon".
export const PPC_NEW_STRATEGY_WARNING_DAYS = 7;
export const DEFAULT_EMPTY_ROW_SIZE = 20;